import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { B as BadgeBase } from './badge-base-439be9eb.js';
import './utils-17533423.js';

const gravityCategoryBadgeCss = ".badge{background-color:var(--gravity-badge-background-color);border-radius:2px;display:flex;pointer-events:none;user-select:auto}.badge--small{--gravity-base-icon-size:14px;height:20px}.badge--large{--gravity-base-icon-size:16px;height:24px}.badge__label{display:block;line-height:0}.badge--overlay{align-items:center;border-radius:2px;box-shadow:inset 0 0 0 1px var(--gravity-badge-border-color, transparent);box-sizing:border-box;display:flex;gap:4px;height:100%;overflow:hidden;padding:0 4px;text-align:center;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.badge--clickable{cursor:pointer;pointer-events:auto}:host{display:inline-block;max-width:100%}.badge--acai{--gravity-badge-background-color:#E3DFF1}.badge--berry{--gravity-badge-background-color:#F0DAF0}.badge--blueberry{--gravity-badge-background-color:#D6E0F5}.badge--ginger{--gravity-badge-background-color:#F6DCCA}.badge--lemon{--gravity-badge-background-color:#F4E194}.badge--lime{--gravity-badge-background-color:#D2EA90}.badge--neutral{--gravity-badge-background-color:#FFFFFF;--gravity-badge-border-color:rgba(0, 15, 30, 0.05)}.badge--tonic{--gravity-badge-background-color:#BFE8F3}.badge--clickable:hover{background-color:rgba(0, 15, 30, 0.05)}";
const GravityCategoryBadgeStyle0 = gravityCategoryBadgeCss;

const GravityCategoryBadge = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.badgeClicked = createEvent(this, "badgeClicked", 7);
        this.handleClick = () => {
            if (this.clickable) {
                this.badgeClicked.emit();
            }
        };
        this.category = 'acai';
        this.clickable = false;
        this.iconName = undefined;
        this.size = 'small';
    }
    render() {
        var _a, _b;
        const title = this.element.title || ((_b = (_a = this.element) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim());
        return (h(BadgeBase, { key: '7b66d69f1b0ba11e2aa1ce2fac478e2822739124', class: `badge--${this.category}`, size: this.size, title: title, iconName: this.iconName, textColor: "dark", clickable: this.clickable, onClick: this.handleClick }, h("slot", { key: '2fad7fa9b4a5dac598b2b6a1bcc25dbc06a73231' })));
    }
    get element() { return getElement(this); }
};
GravityCategoryBadge.style = GravityCategoryBadgeStyle0;

export { GravityCategoryBadge as gravity_category_badge };

//# sourceMappingURL=gravity-category-badge.entry.js.map